module.exports = __webpack_public_path__ + "img/refresh.0d304b47.svg";